import { axiosPrivate } from 'app/utils';

export default {
  async getOrderMessageThreads({ orderId }) {
    const resource = `/v3/orders/${orderId}/message-threads`;
    const response = await axiosPrivate.get(resource);

    return response.data;
  },

  async getMessagesInThread({ messageThreadId, page, limit }) {
    const queryParams = new URLSearchParams();
    if (typeof page === 'number') queryParams.set('page', page);
    if (typeof limit === 'number') queryParams.set('limit', limit);
    const queryString = queryParams.toString();

    const resource = [`/v3/message-threads/${messageThreadId}/messages`, queryString]
      .filter(Boolean)
      .join('?');
    const response = await axiosPrivate.get(resource);

    return response.data;
  },

  async sendOrderMessage({ orderId, content }) {
    const resource = `/v3/orders/${orderId}/messages`;
    const response = await axiosPrivate.post(resource, { content });

    return response.data;
  },

  async closeOrderMessageThread({ messageThreadId }) {
    const resource = `/v3/message-threads/${messageThreadId}/close`;
    const response = await axiosPrivate.patch(resource);

    return response.data;
  },

  async openOrderMessageThread({ messageThreadId }) {
    const resource = `/v3/message-threads/${messageThreadId}/open`;
    const response = await axiosPrivate.patch(resource);

    return response.data;
  },
};
